<template>
  <div class="width-block mt-md-n5">
    <div class="mt-5 mt-lg-n5 mb-4">
      <h1 class="mb-5 custom-size-48">
        {{ $t('login.imgText.challengeInefficientProduction') }}
      </h1>
      <h3 class="d-flex">
        K
        <span class="text-primary">OEE</span>
        BOX - {{ $t('login.imgText.solvingComplexProblems') }}
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextForLoginRegisterPage',
};
</script>

<style lang="scss" scoped>
.width-block {
  width: 70%;
}
.custom-size-48 {
  font-size: 48px;
}
@media (max-width: 767.9px) {
  .width-block {
    width: 80%;
  }
  .custom-size-48 {
    font-size: 36px;
  }
  h3 {
    font-size: 18px;
  }
}
</style>
